import { Contract } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import i18next from 'i18next';
import middleware from 'middleware';
import { useEffect } from 'react';
import {
  useGetDigitalDistributionSectionTemplate,
  useGetDigitalDistributionTemplateLightList,
} from 'services/templates/digital-distribution-template';
import { TEMPLATE_TYPE } from 'services/templates/types';
import { addItem, getExtremeId } from 'utils/dnd/dndUtilities';

const ContractSideMenuDigitalDistribution = () => {
  const { values, setFieldValue, namePrefix, setErrors } = useFormikContractHelpers();

  const digitalDistributionLightList =
    useGetDigitalDistributionTemplateLightList();

  const selectedId = values.sideMenu?.customTemplate?.selectedId;

  const parentId = values.sideMenu?.customTemplate?.parentId;

  const digitalDistributionTemplate = useGetDigitalDistributionSectionTemplate(
    selectedId ?? '',
    {
      notFoundPath: undefined,
      notFoundToastError: i18next.t('toast-message.not-found'),
    },
    !!selectedId,
    false
  );

  useEffect(() => {
    if (!!selectedId && digitalDistributionTemplate.data && parentId) {
      const contractTemplateForm = middleware.template.digitalDistribution.queryToForm(
        digitalDistributionTemplate.data,
        `${parseInt(getExtremeId(values.items)) + 1}`
      );

      const digitalDistribution = contractTemplateForm[0].children[0];

      if (contractTemplateForm) {
        setFieldValue(
          namePrefix,
          addItem(values.items, parentId, digitalDistribution)
        );
        setFieldValue('sideMenu', undefined);
        setErrors({})
      }
      console.log(
        'useEffect - digitalDistributionTemplate',
        selectedId,
        digitalDistributionTemplate.data
      );
    }
  }, [selectedId, digitalDistributionTemplate.data]);

  return (
    <Contract.SideMenu.TemplatesList.Wrapper
      templates={digitalDistributionLightList.data}
      templateType={TEMPLATE_TYPE.digitalDistribution}
      item={template => (
        <Contract.SideMenu.TemplatesList.ListItem
          key={template.id}
          template={template}
        />
      )}
    />
  );
};

export default ContractSideMenuDigitalDistribution;
